import React from 'react';
import "./Flashcards.css";
export const Flashcards = () => {


    return (
        <main>
            Flashcards page
        </main>
    )}